import { useContext } from 'react';
import { Context } from 'react';
import { IdentityContextType } from '../types';

/**
 * Create a hook to use the identity context
 */
export function createUseIdentity<TRole>(
  identityContext: Context<IdentityContextType<TRole>>
) {
  return function useIdentity() {
    const context = useContext(identityContext);
    if (!context) {
      throw new Error('useIdentity must be used within an IdentityContextProvider');
    }
    return context;
  };
}

/**
 * Create a hook to check if user has specific roles
 */
export function createUseHasRole<TRole>(
  identityContext: Context<IdentityContextType<TRole>>
) {
  return function useHasRole(roles: TRole | TRole[]): boolean {
    const { assignedRoles, loadingRoles } = useContext(identityContext);
    
    if (loadingRoles) return false;
    
    const rolesToCheck = Array.isArray(roles) ? roles : [roles];
    return assignedRoles.some(role => rolesToCheck.includes(role));
  };
}
